import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const LA_TZ = 'America/Los_Angeles';

export default function formatSclaDate(
  value: string | Date | null | undefined,
  withWeekday = false,
): string {
  if (!value) return '';
  const parsed = dayjs(value);
  if (!parsed.isValid()) return '';
  const pattern = withWeekday ? 'ddd, MMM D, YYYY' : 'MMM D, YYYY';
  return parsed.tz(LA_TZ).format(pattern);
}
